module.exports = __webpack_public_path__ + "img/rent_property.af1a50c7.svg";